import { DELETE_ALL_INCOMES_SUCCESS, LOGGED_OUT, SET_INCOME_SUCCESS, USER_SUCCESS, } from 'actions/types';
import { REHYDRATE } from 'redux-persist';
import { GET_INVITES_FOR_SPACE_SUCCESS, GET_SPACES_FAILURE, GET_SPACES_REQUEST, GET_SPACES_SUCCESS, GET_SPACE_INFO_SUCCESS, GET_SPACE_INVITE_DETAILS_SUCCESS, SELECTED_SPACE, SET_SHOW_SPACE_LOCK, apiEvents, } from '../constants';
export const defaultSpaceInvites = {
    pending: [],
    rejected: [],
    cancelled: [],
    accepted: [],
};
export const initialState = {
    spaceInfo: {},
    selectedSpace: undefined,
    previousSpace: undefined,
    spaceInvites: {
        '-1': defaultSpaceInvites,
    },
    spaceInviteInfo: {},
    fetchingMySpaces: false,
    showSpaceLock: false,
};
const spaces = (state = initialState, action) => {
    switch (action.type) {
        case REHYDRATE: {
            const { spaces } = action.payload || {};
            if (spaces) {
                return {
                    ...state,
                    ...spaces,
                    fetchingMySpaces: true,
                };
            }
            return {
                ...state,
            };
        }
        case GET_SPACE_INFO_SUCCESS:
            return {
                ...state,
                spaceInfo: {
                    ...state.spaceInfo,
                    [action.payload.space.id]: {
                        ...action.payload,
                        space: {
                            ...action.payload.space,
                            usersCount: action.payload.users?.length ?? 0,
                        },
                    },
                },
            };
        case GET_SPACE_INVITE_DETAILS_SUCCESS:
            return {
                ...state,
                spaceInviteInfo: {
                    ...state.spaceInviteInfo,
                    [action.extra.inviteId]: action.payload,
                },
            };
        case GET_INVITES_FOR_SPACE_SUCCESS:
            return {
                ...state,
                spaceInvites: {
                    ...state.spaceInvites,
                    [action.extra.spaceId]: action.payload,
                },
            };
        case GET_SPACES_REQUEST: {
            return {
                ...state,
                fetchingMySpaces: true,
            };
        }
        case GET_SPACES_FAILURE:
            return {
                ...state,
                fetchingMySpaces: false,
            };
        case GET_SPACES_SUCCESS: {
            const spaceInfo = action.payload.spaces.reduce((prev, curr) => {
                if (state.spaceInfo[curr.id]) {
                    return {
                        ...prev,
                        [curr.id]: {
                            ...state.spaceInfo[curr.id],
                            space: curr,
                        },
                    };
                }
                return {
                    ...prev,
                    [curr.id]: { space: curr },
                };
            }, {});
            return {
                ...state,
                spaceInfo,
                fetchingMySpaces: false,
            };
        }
        case SELECTED_SPACE:
            return {
                ...state,
                selectedSpace: action.payload,
                previousSpace: state.selectedSpace,
            };
        case DELETE_ALL_INCOMES_SUCCESS:
        case SET_INCOME_SUCCESS: {
            const id = state.selectedSpace;
            if (id === undefined || !state.spaceInfo[id]) {
                return state;
            }
            return {
                ...state,
                spaceInfo: {
                    ...state.spaceInfo,
                    [id]: {
                        ...state.spaceInfo[id],
                        space: {
                            ...state.spaceInfo[id].space,
                            currentPaydayRange: action.type === DELETE_ALL_INCOMES_SUCCESS
                                ? undefined
                                : action.payload.income.currentPaydayRange,
                        },
                    },
                },
            };
        }
        case USER_SUCCESS:
            if (action.payload.lastUsedSpaceId &&
                action.payload.lastUsedSpaceId !== state.selectedSpace)
                return {
                    ...state,
                    selectedSpace: action.payload.lastUsedSpaceId,
                    previousSpace: state.selectedSpace,
                };
            if (state.selectedSpace !== undefined) {
                return state;
            }
            return { ...state, selectedSpace: action.payload.defaultSpaceId };
        case 'SAVE_LAST_USED_SUCCESS':
            return {
                ...state,
                previousSpace: action.extra.spaceId,
            };
        case SET_SHOW_SPACE_LOCK:
            return { ...state, showSpaceLock: action.payload };
        case apiEvents.deleteSpaceMember[1]: {
            // The API middleware also dispatches this action type with the raw
            // server response as payload (no spaceId/userId). Ignore it, and never
            // create a spaceInfo entry for a space we don't already know about.
            const { spaceId, userId } = (action.payload ?? {});
            if (spaceId === undefined) {
                return state;
            }
            const existing = state.spaceInfo[spaceId];
            if (!existing?.space) {
                return state;
            }
            const updatedUsers = existing.users?.filter((user) => user.id !== userId);
            return {
                ...state,
                spaceInfo: {
                    ...state.spaceInfo,
                    [spaceId]: {
                        ...existing,
                        users: updatedUsers,
                        space: {
                            ...existing.space,
                            usersCount: updatedUsers?.length ?? existing.space.usersCount,
                        },
                    },
                },
            };
        }
        case LOGGED_OUT:
            return initialState;
        default:
            return state;
    }
};
export { spaces };
